import React, {useState} from 'react';
import classNames from 'classnames';
import {getMPPEndpoint, getHeaders} from '../../../../../../helpers/endpoint';
import {useDispatch} from 'react-redux';
import Loader from '../../../../../../components/Loader';
import DateRangePickerWrapper from '../../../../../../components/DatePicker/DateRangePickerWrapper';
import moment from 'moment';
import {BOGetContestsSizeResponse} from '@fantaleague/mpp_types';

export interface IChallengesStats {
  [key: string]: {
    min: number;
    max: number;
    average: number;
    users: number;
  };
}

const AverageLeaguesSize = () => {
  const dispatch = useDispatch();

  const [lang, setLang] = useState('fr-FR');
  const [startDate, setStartDate] = useState(
    moment(new Date().setDate(new Date().getDate() - 30)).format('YYYY-MM-DD'),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD'),
  );
  const [leagueStats, setLeagueStats] = useState<
    BOGetContestsSizeResponse | undefined
  >(undefined);
  const [challengesStats, setChallengesStats] = useState<
    BOGetContestsSizeResponse | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const getAverageContestsSize = () => {
    return (_dispatch, getState) => {
      setIsLoading(true);
      return Promise.all([
        fetch(
          getMPPEndpoint('getAverageContestsSize', {
            contestType: 'challenge',
            payload: {startDate: startDate, endDate: endDate},
          }),
          {
            method: 'GET',
            headers: getHeaders(getState().authentication),
          },
        ).then(value => value.json()),
        fetch(
          getMPPEndpoint('getAverageContestsSize', {
            contestType: 'league',
            payload: {startDate: startDate, endDate: endDate},
          }),
          {
            method: 'GET',
            headers: getHeaders(getState().authentication),
          },
        ).then(value => value.json()),
      ])
        .then(([challengeData, leagueData]) => {
          setLeagueStats(leagueData);
          setChallengesStats(challengeData);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    };
  };

  const renderTable = (contestType: BOGetContestsSizeResponse, id: string) => {
    const totalContests = Object.values(contestType).reduce(
      (acc, value) => acc + value.totalContests,
      0,
    );
    const ranges = Object.entries(contestType);

    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Nombre de joueurs</th>
              <th className="text-center">Nombre de ligues</th>
              <th className="text-center">%</th>
            </tr>
          </thead>
          <tbody>
            {ranges.map(([range, values], index) => (
              <tr key={`${id}-${range}`} data-target={`.${id}-${range}`}>
                <td className="text-center" style={{width: '150px '}}>
                  <div key={index}>{range}</div>
                </td>

                <td className="text-center">
                  <div key={index}>{values.totalContests}</div>
                </td>
                <td className="text-center">
                  <div key={index}>{values.percentage}%</div>
                </td>
              </tr>
            ))}
            <tr key={`${id}-total`} data-target={`.${id}-total`}>
              <td className="text-center" style={{width: '150px '}}>
                <b>Total</b>
              </td>
              <td className="text-center">
                <b>{totalContests}</b>
              </td>
              <td className="text-center">
                <b>100%</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const renderLeaguesSizes = () => {
    if (!leagueStats || !challengesStats) {
      return null;
    }
    const contestsStats = Object.values({challengesStats, leagueStats}).map(
      element => {
        return element;
      },
    );

    return contestsStats.map((contestType, index) => {
      const id = `leaguesByModeByStatus-${index}`;
      return (
        <div key={id} id={id} className="mb-4">
          <h3 className="my-0 ml-3">{index === 0 ? 'Classique' : '1vs1'}</h3>
          {renderTable(contestType, id)}
        </div>
      );
    });
  };

  return (
    <div className="leagues-stats-widget">
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title pull-left">
            <i className="fa fa-users" /> Taille moyenne des ligues
          </h3>
        </div>
        <div className="box-body">
          <div className="text-center">
            <div className="inline lang">
              <button
                className={classNames('btn btn-box-tool', {
                  selected: lang === 'fr-FR',
                })}
                onClick={() => setLang('fr-FR')}>
                <span className="flag-icon flag-icon-fr" />
              </button>
            </div>
            <div className="period-filter inline data-range-picker">
              <DateRangePickerWrapper
                initialStartDate={moment(startDate)}
                initialEndDate={moment(endDate)}
                minimumNights={0}
                onDatesChange={({startDate, endDate}) => {
                  setStartDate(moment(startDate).format('YYYY-MM-DD'));
                  setEndDate(moment(endDate).format('YYYY-MM-DD'));
                }}
              />
              <button
                className="mb-1 inline btn btn-default btn-flat"
                onClick={() => {
                  dispatch(getAverageContestsSize());
                }}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
        </div>
        {isLoading && <Loader />}
        {renderLeaguesSizes()}
      </div>
    </div>
  );
};

export default AverageLeaguesSize;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/components/AverageLeaguesSize/index.tsx